
var guidUtil = require('../../guid/guidUtil.js');
var logger = require('../../logger/logger');
var salesStatusUtil = require('../../domain/sales/salesStatusUtil.js');
var salesLoader = require('../../domain/sales/salesLoader');
var stateManager = require('../../state/stateManager');
var todaysSalesUpdatedDateTimeAction = require('../../state/actions/sales/todaysSalesUpdatedDateTimeAction');
var stringUtil = require('../../string/stringUtil');
var businessDateUtil = require('../../dateUtil/businessDateUtil');
var dateUtil = require('../../dateUtil/dateUtil');
var saleContextUtil = require('../../../views/Order/utils/saleContextUtil.js');



module.exports.handleMessage = function(messagePayload)
{
    var tracingContext = createTracingContext(messagePayload);

    try
    {
        if (messagePayload.type == "sale")
        {
            let todaySales = stateManager.getStore().getState().todaySales;
            let sale = messagePayload.sale;

            if(!dateUtil.isSame(businessDateUtil.getTodayBusinessDate(), businessDateUtil.getPropertyBusinessDateFromUtcDateTime(sale.dateTime)))
            {
                /*
                    The following condition is for a use case when
                        -) Sale occurred at 01:30 AM and then subsequent change was made at 02:10 AM (during closing hours)
                    
                    since now date is changed, we would like to keep showing this sale on screen.
                */

                if (!todaySales.find(snapshot => stringUtil.areStringSame(snapshot.id == sale.id)))
                    return;
            }


            todaySales = todaySales.filter(s => !stringUtil.areStringSame(s.id, sale.id));
            todaySales.push(sale);
            stateManager.getStore().getState().todaySales = todaySales;
            salesLoader.initializeSale(sale);

            stateManager.getStore().dispatch(todaysSalesUpdatedDateTimeAction.createAction());

            let saleContext = stateManager.getStore().getState().saleContext;
            if (saleContext != null && saleContext.sale != null && stringUtil.areStringSame(saleContext.sale.id, sale.id))
            {
                saleContextUtil.replaceSaleWithLatestSale();
            }

            logger.info('Sale Message processed successfully', tracingContext);
            return;
        }

        if (messagePayload.type == "sale.status")
        {
            var loadedStatusLines = messagePayload.statusLines;
            if (loadedStatusLines == null || loadedStatusLines.length <= 0)
            {
                logger.warn('Sale Status Message is ignored as status lines are empty or null', tracingContext);
                return;
            }

            logger.info('Sale Status Message is being processed', tracingContext);
            let todaySales = stateManager.getStore().getState().todaySales;
            var updatedSaleIds = salesStatusUtil.addNewStatusLinesIfLatest(loadedStatusLines);

            updatedSaleIds.forEach(saleId =>
            {
                var sale = todaySales.find(s => stringUtil.areStringSame(s.id, saleId));
                if (sale != null)
                    salesLoader.initializeSale(sale);  
            })
            if (updatedSaleIds.length > 0)
            {
                stateManager.getStore().dispatch(todaysSalesUpdatedDateTimeAction.createAction());
            }
            logger.info('Sale Status Message processed successfully', tracingContext);
            return;
        }
    }
    catch(err)
    {
        logger.error('Error occurred while handling message in sale channel. ', tracingContext, err);
    }
}


function createTracingContext(payload)
{
    var tracingContext = {};
    if (payload.tracingContext != null)
    {
        tracingContext = payload.tracingContext;
        delete payload.tracingContext;
        return tracingContext;
    }
    
    tracingContext.traceId = guidUtil.generateGuid();
    Object.assign(tracingContext, payload);
    return tracingContext;
}



